'use strict';

angular.module('mobile-apps').factory('LanguageEntries', [
    '$resource',
    function ($resource) {
        return $resource(
            'v1/projects/:mobileAppId/languages/:languageId/entries/:entryId',
            {
               /* mobileAppId: '@_id',
                languageId : '@_id',*/
                mobileAppId: '@mobileAppId',
                entryId    : '@_id'
                //groupId    : '@_id'
            },
            {
                get:
                {
                    method:'GET',
                    cache : false
                },
                valueList:
                {
                    url : '/v1/projects/:mobileAppId/languages/:languageId/groups/:groupId/entries',
                    method:'GET',
                    cache : false,
                    isArray: false
                },
                keyList:
                {
                    url : '/v1/projects/:mobileAppId/groups/:groupId/entries',
                    method:'GET',
                    cache : false,
                    isArray: true
                },
                update:
                {
                    method: 'PUT',
                    cache: false
                },
                save:
                {
                    url : '/v1/projects/:mobileAppId/languages/:languageId/groups/:groupId/entries',
                    method: 'POST',
                    cache: false
                },
                remove:
                {
                    method: 'DELETE',
                    cache: false
                },
				addRemoveTags:
				{
					url : '/v1/projects/:mobileAppId/entries/addRemoveTags',
					method: 'POST',
					cache: false
				}
            }
        );
    }
]);
